import { useMutation } from 'common/hooks';
import { sendChangePasswordEmailApi } from '../accounts.service';

export const useSendChangePasswordEmail = () => {
  return useMutation(sendChangePasswordEmailApi, {
    showSuccessSnackbar: true,
  });
};
